import React, { useEffect, useState } from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import { Storage } from '../lib'

export const PublicHome: React.FC = () => {
  const [users, setUsers] = useState<any[]>([])
  const history = useHistory()

  useEffect(() => {
    const profilesObj = Storage.getBackup() || {}
    const profiles = Object.keys(profilesObj)
      .filter(key => key?.length > 0)
      .map(key => profilesObj[key])
    for (const user of profiles) {
      let [nextScore, nextErrors, nextSuccessRate] = [0, 0, 0]
      Object.keys(user.games).forEach((g: any) => {
        nextScore += user.games[g].score
        nextErrors += user.games[g].errors
      })
      nextSuccessRate = 100 - nextErrors / ((nextScore + nextErrors) / 100)
      user.score = nextScore
      user.errors = nextErrors
      user.successRate = isNaN(nextSuccessRate) ? 0 : nextSuccessRate
      user.timeMs = isNaN(user.timeMs) ? 0 : user.timeMs
      user.sortBy = user.score * 30 + user.successRate * 10 + (3000 - user.timeMs / 1000)
    }
    setUsers(profiles.sort((a: any, b: any) => (a.sortBy === b.sortBy ? 0 : a.sortBy > b.sortBy ? -1 : 1)))
  }, [])

  return (
    <div className="view background-summer">
      <div
        className="p-10 text-black"
        style={{
          maxWidth: window.innerWidth > 768 ? '70vw' : '96vw',
          width: window.innerWidth > 768 ? '70vw' : '96vw',
        }}
      >
        <div className="card glass p-5">
          <h1 className="text-left text-2xl font-bold mb-5">Lesníkův učeň</h1>
          <p className="text-left font-bold mb-2">Kdo se stane malým lesníkem?</p>
          <p className="text-left">
            V prvním kole pomoz lesníkovi získat sněžnice a teplý hubertus, aby se mohl o les starat i v zimě ve druhém
            kole. Nezapomeň si po skončení hry vytisknout diplom a pochlubit se kamarádům se svými výsledky. Hra je
            určena především pro děti ve věku od 7 do 15 let, ale vítáni jsou všichni přátelé lesa a přírody.
          </p>
          <div className="mt-5">
            <NavLink to={'/login'} className="btn btn-primary text-2xl btn-lg">
              Pokračovat ke hře
            </NavLink>
          </div>
        </div>
        {users?.length > 0 && (
          <div className="w-full card glass p-5 mt-10 max-h-96 overflow-y-auto">
            <h1 className="text-left text-2xl font-bold mb-5">Výsledky</h1>
            <table className="table table-zebra table-compact w-full">
              <thead>
                <tr>
                  <th>Jméno</th>
                  <th>Úspěšnost</th>
                  <th>Skóre</th>
                  <th>Chyby</th>
                  <th>Čas</th>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (
                  <tr key={user.username}>
                    <th className="capitalize">{user.username}</th>
                    <td>{Math.floor(user.successRate || 0)}%</td>
                    <td>{user.score}</td>
                    <td>{user.errors}</td>
                    <td>{Math.floor(user.timeMs / 1000)}s</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div className="fixed z-10 bottom-0 left-5">
          <button className="text-xl text-black btn btn-block mb-5 glass" onClick={() => history.push('/o-aplikaci')}>
            o aplikaci
          </button>
        </div>
      </div>
    </div>
  )
}
